import { GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { AnyAction } from 'redux';

export const mindestvertragslaufzeitReducer = function (
  sectionState: boolean = false,
  action: AnyAction,
): boolean {
  if (action.type === GlobalActions.MINDESTVERTRAGSLAUFZEIT_CHECKBOX_CHANGED) {
    return !!action.payload;
  }
  return sectionState;
};
